import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LockIcon from "@mui/icons-material/Lock";

const PLACEHOLDER_BADGES = [
  { emoji: "🎯", name: "???" },
  { emoji: "🚀", name: "???" },
  { emoji: "⚡", name: "???" },
  { emoji: "💯", name: "???" },
  { emoji: "🎨", name: "???" },
  { emoji: "🌅", name: "???" },
  { emoji: "🦉", name: "???" },
  { emoji: "🔥", name: "???" },
];

const AchievementsGallery = () => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={handleToggle}
      className="achievements-gallery"
      sx={{
        background: "rgba(255,255,255,0.95)",
        borderRadius: "20px !important",
        marginBottom: "16px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
        overflow: "hidden",
        "&:before": {
          display: "none",
        },
        "&.Mui-expanded": {
          margin: "0 0 16px 0",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "#333" }} />}
        sx={{
          padding: "20px 24px",
          minHeight: "auto",
          "&.Mui-expanded": {
            minHeight: "auto",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            "&.Mui-expanded": {
              margin: 0,
            },
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Box
            sx={{
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #813773 0%, #a04990 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
              boxShadow: "0 4px 12px rgba(129, 55, 115, 0.3)",
            }}
          >
            <EmojiEventsIcon sx={{ color: "#fff", fontSize: "22px" }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
              Achievements
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(0,0,0,0.5)" }}>
              Track your progress
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "0 24px 24px 24px" }}>
        {/* Locked content with blurred placeholder badges */}
        <Box sx={{ position: "relative" }}>
          {/* Blurred placeholder badges */}
          <Box
            sx={{
              display: "flex",
              gap: "12px",
              overflowX: "hidden",
              paddingBottom: "8px",
              filter: "blur(6px)",
              opacity: 0.4,
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            {PLACEHOLDER_BADGES.map((badge, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "16px 12px",
                  borderRadius: "16px",
                  background: "rgba(200,200,200,0.3)",
                  minWidth: "90px",
                  maxWidth: "110px",
                }}
              >
                <Box
                  sx={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    background: "rgba(150,150,150,0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "8px",
                    border: "2px solid rgba(150,150,150,0.3)",
                  }}
                >
                  <Typography sx={{ fontSize: "24px", lineHeight: 1 }}>
                    {badge.emoji}
                  </Typography>
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    color: "#888",
                    textAlign: "center",
                    fontSize: "0.75rem",
                  }}
                >
                  {badge.name}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Coming Soon overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <LockIcon
              sx={{ fontSize: "28px", color: "#813773", opacity: 0.7 }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#813773",
                fontSize: "0.95rem",
                letterSpacing: "0.5px",
              }}
            >
              Coming Soon
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "rgba(0,0,0,0.45)",
                textAlign: "center",
                maxWidth: "240px",
              }}
            >
              Achievements are on their way. Stay tuned!
            </Typography>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default AchievementsGallery;
